import { render } from "./App.vue?vue&type=template&id=5b1eadbf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5b1eadbf&lang=css"

import exportComponent from "/Users/Crossover/src/totogi-demo-video-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__